export default __webpack_public_path__ + "static/media/Ballroll_00242.9ab71213.png";